import { useEffect } from 'react'

export function useSessionTimer(
  isTimerRunning: boolean,
  setDuration: (updater: (duration: number) => number) => void
) {
  useEffect(() => {
    let interval: NodeJS.Timeout

    if (isTimerRunning) {
      interval = setInterval(() => {
        setDuration((current) => current + 1)
      }, 1000)
    }

    return () => clearInterval(interval)
  }, [isTimerRunning, setDuration])
}
